import { getResource } from '../utilities/service-utils'

export const fetchLogs = (hmkey) => {
    return getResource(`hmlog/fetchLogs/${hmkey}`)
  }
  